<template>
  <div class="container">
    <!--轮播图-->
    <!--swiper的轮播图-->
    <div class="content">
      <img src="@assets/images/znshj.jpg" style="width:100%;" />
    </div>
    <!--店铺列表-->
    <ul class="flagship">
      <li style="height:75px" v-for="(item,index) in shops" :key="index">
        <a class="clear_fix" v-if="item.type==0" @click="goATM(item.id)">
          <div class="shop_logo f_left">
            <img src="@assets/images/shop_logo.png" alt />
            <img class="jiaobiao" src="@assets/images/jiaobiao_1.png" alt />
          </div>
          <div class="shop_desc f_left">
            <p class="shopname">{{item.name}}</p>
            <p class="enter">进入店铺 &gt;&gt;</p>
          </div>
          <div class="shops f_right">
            <p>
              <img style="width:19.2px" src="@assets/images/qjd.png" alt />
            </p>
            <p class="shop_type" style="color:#D93B29;font-size:12px;">旗舰店</p>
            <div class="distance">运营中</div>
            <div class="distance">运营中</div>
          </div>
        </a>

        <a class="clear_fix" v-else @click="goATM(item.id)">
          <div class="shop_logo f_left">
            <img src="@assets/images/shop_logo.png" alt />
            <img class="jiaobiao" src="@assets/images/jiaobiao_2.png" alt />
          </div>
          <div class="shop_desc f_left">
            <p class="shopname">{{item.name}}</p>
            <p class="enter">进入店铺 &gt;&gt;</p>
          </div>
          <div class="shops f_right">
            <p>
              <img style="width:19.2px" src="@assets/images/shj.png" alt />
            </p>
            <p class="shop_type" style="color:#6851A2;font-size:12px;">售货机</p>
            <div class="distance">运营中</div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import { getShops } from "@api/store";

export default {
  name: "Shops",
  data: function() {
    return {
      shops: []
    };
  },
  methods: {
    goATM(id) {
      this.$router.push({ path: "/atm", query: { type: id } });
    }
  },
  mounted() {
    var that = this
    var type = this.$route.query.type
    var q = { type: type };
    getShops(q).then(res => {
      that.shops = res.data;
    });
  },
  watch: {
    $route(to, from) {
      var that=this
      var type = this.$route.query.type
      var q = { type: type };
      getShops(q).then(res => {
        that.shops = res.data;
      });
    }
  }
};
</script>

<style scoped>
.flagship {
  list-style: none;
  display: flex;
  flex-flow: column;
}
.f_left {
  float: left;
}
.f_right {
  float: right;
}
.clearfix::before,
.clearfix::after {
  content: "";
  line-height: 0;
  height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}
.p_rel {
  position: relative;
}
.p_abs {
  position: absolute;
}
.none {
  display: none;
}

/*弹出提示框*/

.age-alert {
  width: 100%;
  max-width: 1080px;
  height: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.8);
  left: 0;
  top: 0;
  z-index: 100000;
  display: none;
}

.prompt {
  font-size: 36px;
  color: #f10215;
  text-align: center;
  padding-top: 20px;
}

.alert-box {
  width: 300px;
  height: 500px;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -150px;
  margin-top: -250px;
  box-shadow: #fff 0 0 20px;
}

.btn-box {
  width: 300px;
  position: absolute;
  bottom: 0;
  left: 0;
}

.allow-desc {
  padding: 20px 20px;
  font-size: 28px;
}

.btn-box p {
  line-height: 60px;
  width: 50%;
  float: left;
  text-align: center;
  font-size: 25px;
  color: #fff;
}

.under {
  background: #f10215;
}

.blow {
  background: #999;
}

body {
  font-family: PingFangSC-Regular, Helvetica, "Droid Sans", Arial, sans-serif;
  background-color: #eee;
}
.container {
  width: 100%;
  max-width: 640px;
  position: relative;
  margin: 0 auto;
  -background: tomato;
  min-width: 320px;
}
.swiper-container {
  /*height: 640px!important;*/
}
.swiper-slide img {
  width: 100%;
  height: 100%;
  display: block;
}
.swiper-container > .swiper-pagination {
  position: absolute;
  z-index: 1000;
  text-align: center;
  bottom: 3px !important;
}
.swiper-pagination-bullet {
  background: #fff !important;
}
.swiper-pagination-bullet-active {
  background: red !important;
}
/*.flagship{
				height: 75px;
				background-color: tomato;
			}*/
ul li {
  width: 100%;
  height: 75px;
  margin-top: 10px;
  background: #fff;
}
ul li a {
  display: block;
  height: 75px;
}
.shop_logo {
  width: 45px;
  height: 45px;
  margin-top: 15px;
  margin-left: 20px;
  position: relative;
}
.shop_logo img:nth-child(1) {
  width: 100%;
  height: 100%;
}
.shop_desc {
  height: 35px;
  margin-top: 20px;
  margin-left: 15px;
}
.shops {
  width: 85px;
  height: 55px;
  margin-top: 5px;
  margin-right: 15px;
}

.jiaobiao {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 15px;
}
.shopname {
  color: #212121;
}
.enter {
  color: #bdbcbc;
  margin-top: 2px;
}
.shops p {
  text-align: center;
  -margin-top: 20px;
}
.distance {
  text-align: center;
  height: 20px;
  line-height: 20px;
  background: #bdbcbc;
  border-radius: 20px;
  font-size: 12px;
  color: #fff;
}
</style>